<template>
  <section v-if="itemDescriptions?.length" class="skin-descriptions">
    <h2>{{ t('Description') }}</h2>
    <div class="skin-descriptions_wrap">
      <!--      <div-->
      <!--          v-for="(desc) of descriptions"-->
      <!--          :key="desc.name"-->
      <!--          class="skin-descriptions&#45;&#45;item card-dark"-->
      <!--      >-->
      <!--        <div class="skin-descriptions&#45;&#45;item_header">-->
      <!--          <i :class="`i-${desc.name}`"></i>-->
      <!--          <h3>{{-->
      <!--              t(`descriptions.${desc.name}.title`, {-->
      <!--                name: props.item.locals?.localed_name ||-->
      <!--                    props.item.market_hash_name-->
      <!--              })-->
      <!--            }}</h3>-->
      <!--        </div>-->
      <!--        <div class="skin-descriptions&#45;&#45;item_body">-->
      <!--          <p v-html="desc.text"></p>-->
      <!--        </div>-->
      <!--      </div>-->
      <template
          v-for="(desc) of itemDescriptions"
          :key="desc.title"
      >
        <div
            v-if="desc.value"
            class="skin-descriptions--item card-dark"
        >
          <div class="skin-descriptions--item_header">
            <svg v-if="desc.icon" height="24" width="24">
              <use :xlink:href="`/icons/sprite.svg#${desc.icon}`"></use>
            </svg>
            <i v-else class="i-rarity"></i>
            <h3>{{ desc.title }}</h3>
          </div>
          <div class="skin-descriptions--item_body">
            <p v-html="desc.value"></p>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n'
import type {Description, ItemPageInfo} from "~/graphql/generated/schema-types";
import {useStore} from "~/store";
import getDropChance from "~/utils/get-drop-chance";

const props = defineProps<{
  item: ItemPageInfo
}>()

const store = useStore()
const currencyName = computed(() => store.currency)
const currency = computed(() => store.rate)
const {t, locale} = useI18n()
const config = useRuntimeConfig()
const siteHost = config.public.siteHost
const icons: Record<string, string> = {
  'Overview': 'i-info',
  "Rarity": 'i-diamond',
  "History": 'clock',
  "Popularity": 'flame',
  "Compatibility": 'i-dumbell',
  "Unique Features": 'settings',
  "Event": 'calendar-star',
  "Trivia": 'i-info',
  "Skin Designer": 'i-brush',
  "Technical Features": 'settings',
  "Reviews and Ratings": 'feedback',
  "Historical Significance": 'clock',
  "Reasons for Popularity": 'flame',
  "Influential Events": 'calendar-star',
  "Creation Story": 'i-info',
  "Symbolism and Design Elements": 'palette',
  "Emotional Connection": 'i-smile',
  "Impact on Community": 'community',
  "Usage in Esports": 'gamepad',
  "Player Stories": 'i-book',
}

function calculatePriceChange(prices: number[], currentPrice: number) {
  // Суммируем все цены за последние 7 дней
  let total = prices.reduce((sum, price) => sum + price, 0);
  // Вычисляем среднюю цену за 7 дней
  let averagePrice = total / prices.length;
  // Рассчитываем абсолютное изменение цены
  let priceChange = currentPrice - averagePrice;
  // Рассчитываем процентное изменение цены
  let percentageChange = (priceChange / averagePrice) * 100;
  // Возвращаем результаты в виде объекта
  return {
    priceChange: priceChange.toFixed(2),
    percentageChange: percentageChange.toFixed(2),
  };
}

let lastWeekPrices: number[] = props.item.seven_days?.map(item => item?.min_price || 0) || []; // Цены за последние 7 дней
let todayPrice = props.item.current_price || 0; // Цена сегодня

const {priceChange, percentageChange} = calculatePriceChange(lastWeekPrices, todayPrice);

const itemDescriptions = computed(() => {
  const replacements: Record<string, string> = {
    lang: locale.value === 'en' ? '' : locale.value,
    'designer-name': props.item.designer_name || 'Valve',
    'designer-url': props.item.designer_link || '#'
  };

  return props.item.descriptions?.filter(desc => desc?.value && desc?.title)?.map(description => {
    let newValue = (description as Description).value;

    for (const [key, value] of Object.entries(replacements)) {
      const regexCurly = new RegExp(`{${key}}`, 'g');
      const regexSquare = new RegExp(`\\[${key}\\]`, 'g');

      newValue = newValue?.replace(regexSquare, value);
      newValue = newValue?.replace(regexCurly, value);
    }
    newValue = newValue?.replace('https://csmarketcap.com', '').replace('/collections', '/containers');

    if (locale.value === 'en') {
      // Удаляем переменную {lang} и последующий слеш, если locale === 'en'
      newValue = newValue?.replace(/\/{lang}\//g, '/')?.replace(/{lang}/g, '');
    }

    newValue = newValue?.replace(/\/\//g, '/');
    // Заменяем теги <a> на <span>
    newValue = newValue?.replace(/<a\b[^>]*>/g, '<span>').replace(/<\/a>/g, '</span>');

    return {
      title: (description as Description).title,
      value: newValue,
      icon: icons[(description as Description).title]
    };
  });
});


const descKeys = computed(() => {
  const name = props.item.locals?.localed_name || props.item.market_hash_name
  const category = props.item.category
  const exterior = props.item.exterior
  const rarity = props.item.locals?.rarity
  const pattern = props.item.locals?.pattern
  const designer = props.item.designer_name
  const currentPrice = `<span class="c-${currencyName.value}">
      ${((props.item.current_price || 0) / 1000 * currency.value).toFixed(2)}
      </span>`

  const marketList = props.item.available_markets?.map(i => i?.toUpperCase())?.join(', ')
  const marketCount = props.item.available_markets?.length
  const popularity = props.item.popularity

  return [
    {
      name: 'float',
      requiredFields: ['min_float', 'max_float'],
      text: t('descriptions.float.value', {
        name,
        category,
        exterior,
        pattern,
        designer,
        currentPrice,
        marketList,
        popularity,
        minFloat: props.item.min_float,
        maxFloat: props.item.max_float
      })
    },
    {
      name: 'rarity',
      requiredFields: ['market_hash_name'],
      text: t('descriptions.rarity.value', {
        name,
        similarLength: props.item.similar_skins?.length || 0,
        rarity,
        pattern,
        dropChance: getDropChance(props.item.locals?.rarity || '', props.item.category)
      })
    },
    {
      name: 'availability',
      requiredFields: ['seven_days', 'available_markets'],
      text: t('descriptions.availability.value', {
        name,
        marketCount,
        lowPrice: `<span class="c-${currencyName.value}">
          ${((props.item.seven_days?.[0]?.min_price || 0) / 1000 * currency.value).toFixed(2)}
          </span>`,
        highPrice: `<span class="c-${currencyName.value}">
          ${((props.item.seven_days?.[0]?.max_price || 0) / 1000 * currency.value).toFixed(2)}
          </span>`

      })
    },
    {
      name: 'community_rating',
      requiredFields: ['votes', 'rating'],
      // requiredFields: ['votes', 'rating', 'players'],
      text: t('descriptions.community_rating.value', {
        name,
        votes: props.item.votes,
        rating: props.item.rating
      })
      // Notably, it is also part of the arsenal of professional CS2 players such as {proPlayersList - у нас такого нет еще}.
    },
    {
      name: 'where_buy',
      requiredFields: ['available_markets'],
      text: t('descriptions.where_buy.value', {
        name,
        marketCount,
        markets: marketList
      })
    },
    {
      name: 'price_trend',
      requiredFields: ['seven_days'],
      text: t('descriptions.price_trend.value', {
        name,
        variation: t(+priceChange > 0 ? 'increased' : 'decreased'),
        percent: percentageChange + '%',
      })
    },
    {
      name: 'avg_price',
      requiredFields: ['seven_days', 'available_markets'],
      text: t('descriptions.avg_price.value', {
        name,
        marketCount,
        averagePrice: `<span class="c-${currencyName.value}">
        ${((props.item.seven_days?.[0]?.avg_price || 0) / 1000 * currency.value).toFixed(2)}
        </span>
      `
      })
    },
  ]
})

const descriptions = computed(() => {
  return descKeys.value.filter(key => {
    return key.requiredFields.every(field => {
      if (Array.isArray((props.item as any)[field])) {
        return (props.item as any)[field] && (props.item as any)[field]?.length
      }
      return (props.item as any)[field]
    })
  })
})
</script>

<style lang="scss" scoped>


.skin-descriptions {
  &_wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    @media screen and (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &--item {
    border-radius: 1rem;

    p {
      font-size: 1.6rem;
      line-height: 2;
      color: var(--surfaces-on-surface);
      opacity: 0.8;
      font-weight: 400;
    }


    &_header {
      min-height: 3rem;
      display: flex;
      align-items: flex-start;
      font-size: 1.8rem;
      gap: 0.8rem;
      margin-bottom: 1.6rem;

      i, svg {
        font-size: 2.4rem;
        margin-top: 4px;
        color: var(--accent-secondary);
      }
    }

    &_body p {
      text-align: justify;

      &:deep(a) {
        text-decoration: underline;
      }
    }
  }
}
</style>
